import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * This can be used when you want to compose modules in react rather in a surface
 * This will split the parent mutate function into mutate functions compatible with the children
 *
 * @param {function} mutate - The mutate function of the parent.
 * @param {Object} mutationArgs - the args that the derived mutate function should receive.
 * @returns The mutate function suitable for the child
 */
export var deriveMutateOfChild = function deriveMutateOfChild(_ref) {
  var mutate = _ref.mutate,
    mutationArgs = _ref.mutationArgs;
  return function (mutation) {
    if (mutation === null) {
      return mutation;
    }
    mutate(function (current) {
      return _objectSpread(_objectSpread({}, current), typeof mutation === 'function' ? mutation(mutationArgs) : mutationArgs);
    });
  };
};